import { combineReducers } from '@reduxjs/toolkit';
import AuthSlice from "./slices/AuthSlice"
import PostSlice from "./slices/PostSlice"
import ShortSlice from "./slices/ShortSlice"
import PlacesSlice from "./slices/PlacesSlice"
import UserSlice from "./slices/User"
import LocationSlice from './slices/LocationSlice';
import CategorySlice from './slices/CategorySlice';
import FcmSlice from './slices/FcmSlice';
import DashboardSlice from './slices/DashboardSlice';
import CommentSlice from './slices/CommentSlice';
import DraftSlice from './slices/DraftSlice';
import PlaceDraftSlice from './slices/PlaceDraftSlice';
import TripDraftSlice from './slices/TripDraftSlice';

const rootReducer = combineReducers({
  auth: AuthSlice,
  post: PostSlice,
  short: ShortSlice,
  places: PlacesSlice,
  user: UserSlice,
  location: LocationSlice,
  category: CategorySlice,
  fcm: FcmSlice,
  dashboard: DashboardSlice,
  comment: CommentSlice,
  draft: DraftSlice,
  placeDraft: PlaceDraftSlice,
  tripDraft: TripDraftSlice,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
